import './app-pages/pages/consult/results/ResultsBar.css';
import './app-pages/pages/messaging/chat/Chat.css';
import './styles/CalendarMobile.css';
import './styles/globals.css';

import { ThemeProvider } from '@emotion/react';
import { theme } from 'components/core/theme';
import { BrowserProvider } from 'contexts/BrowserContext';
import { useScrollOnNavigation } from 'hooks/useScrollOnNavigation';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';

import LeadsRouter from './app-pages/pages/leads/LeadsRouter';
import { MemberRouter } from './MemberRouter';
import { fromSubdomain } from './utils/fromSubdomain';

const queryClient = new QueryClient({});

export function App() {
  useScrollOnNavigation();

  const fromAspSubdomain = fromSubdomain('asp');
  const fromNPSubdomain = fromSubdomain('np');
  const fromReferSubdomain = fromSubdomain('refer');

  const fromMainDomain =
    !fromReferSubdomain && !fromAspSubdomain && !fromNPSubdomain;

  return (
    <BrowserProvider>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            {!fromMainDomain && (
              <LeadsRouter
                fromAspSubdomain={fromAspSubdomain}
                fromNPSubdomain={fromNPSubdomain}
                fromReferSubdomain={fromReferSubdomain}
              />
            )}

            {fromMainDomain && <MemberRouter />}
          </QueryClientProvider>
        </ThemeProvider>
      </HelmetProvider>
    </BrowserProvider>
  );
}
